import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectActiveColleagues,
  selectColleagues,
  selectColleaguesInitializationStatus,
} from "../instructors-slice";
import { fetchColleagues } from "../slice-extensions/instructors-slice-extension";

/**
 * Loads the organization roster once (guarded by the initialization status)
 * and reports whether the organization has more than one active instructor —
 * the switch that turns per-instructor UI (filters, assignment labels) on.
 */
export const useColleagues = () => {
  const dispatch = useAppDispatch();
  const colleagues = useAppSelector(selectColleagues);
  const activeColleagues = useAppSelector(selectActiveColleagues);
  const initStatus = useAppSelector(selectColleaguesInitializationStatus);

  useEffect(() => {
    if (initStatus === "not-initialized") {
      dispatch(fetchColleagues());
    }
  }, [dispatch, initStatus]);

  return {
    colleagues,
    activeColleagues,
    isMultiInstructor: activeColleagues.length > 1,
  };
};
